import { GrantOrganizationUserRolesPayload, RevokeOrganizationUserRolesPayload } from './organization-user.types';

export const DELETE_ORGANIZATION_USER_STORE_KEY = 'ORGANIZATION_USER/DELETE_ORGANIZATION_USER';
export const DELETE_ORGANIZATION_USER_API_REQUESTED = `ORGANIZATION_USER/DELETE_ORGANIZATION_USER_API_REQUESTED`;
export const DELETE_ORGANIZATION_USER_API_SUCCESS = 'ORGANIZATION_USER/DELETE_ORGANIZATION_USER_API_SUCCESS';
export const DELETE_ORGANIZATION_USER_API_FAILED = 'ORGANIZATION_USER/DELETE_ORGANIZATION_USER_API_FAILED';

export const GRANT_ORGANIZATION_USER_ROLES_STORE_KEY = 'ORGANIZATION_USER/GRANT_ORGANIZATION_USER_ROLES';
export const GRANT_ORGANIZATION_USER_ROLES_API_REQUESTED = 'ORGANIZATION_USER/GRANT_ORGANIZATION_USER_ROLES_API_REQUESTED';
export const GRANT_ORGANIZATION_USER_ROLES_API_SUCCESS = 'ORGANIZATION_USER/GRANT_ORGANIZATION_USER_ROLES_API_SUCCESS';
export const GRANT_ORGANIZATION_USER_ROLES_API_FAILED = 'ORGANIZATION_USER/GRANT_ORGANIZATION_USER_ROLES_API_FAILED';

export const REVOKE_ORGANIZATION_USER_ROLES_STORE_KEY = 'ORGANIZATION_USER/REVOKE_ORGANIZATION_USER_ROLES';
export const REVOKE_ORGANIZATION_USER_ROLES_API_REQUESTED = 'ORGANIZATION_USER/REVOKE_ORGANIZATION_USER_ROLES_API_REQUESTED';
export const REVOKE_ORGANIZATION_USER_ROLES_API_SUCCESS = 'ORGANIZATION_USER/REVOKE_ORGANIZATION_USER_ROLES_API_SUCCESS';
export const REVOKE_ORGANIZATION_USER_ROLES_API_FAILED = 'ORGANIZATION_USER/REVOKE_ORGANIZATION_USER_ROLES_API_FAILED';

export function deleteOrganizationUserRequested(payload: string) {
  return {
    type: DELETE_ORGANIZATION_USER_API_REQUESTED,
    payload,
  } as const;
}

export function deleteOrganizationUserSuccess(payload: string) {
  return {
    type: DELETE_ORGANIZATION_USER_API_SUCCESS,
    payload,
  } as const;
}

export function deleteOrganizationUserFailed(error: string) {
  return {
    type: DELETE_ORGANIZATION_USER_API_FAILED,
    payload: error,
  } as const;
}

export function grantOrganizationUserRolesRequested(payload: GrantOrganizationUserRolesPayload) {
  return {
    type: GRANT_ORGANIZATION_USER_ROLES_API_REQUESTED,
    payload,
  } as const;
}

export function grantOrganizationUserRolesSuccess() {
  return {
    type: GRANT_ORGANIZATION_USER_ROLES_API_SUCCESS,
  } as const;
}

export function grantOrganizationUserRolesFailed(error: string) {
  return {
    type: GRANT_ORGANIZATION_USER_ROLES_API_FAILED,
    payload: error,
  } as const;
}

export function revokeOrganizationUserRolesRequested(payload: RevokeOrganizationUserRolesPayload) {
  return {
    type: REVOKE_ORGANIZATION_USER_ROLES_API_REQUESTED,
    payload,
  } as const;
}

export function revokeOrganizationUserRolesSuccess(payload: string) {
  return {
    type: REVOKE_ORGANIZATION_USER_ROLES_API_SUCCESS,
    payload,
  } as const;
}

export function revokeOrganizationUserRolesFailed(error: string) {
  return {
    type: REVOKE_ORGANIZATION_USER_ROLES_API_FAILED,
    payload: error,
  } as const;
}

export type OrgnizationUserActionTypes = ReturnType<
  | typeof deleteOrganizationUserRequested
  | typeof deleteOrganizationUserSuccess
  | typeof deleteOrganizationUserFailed
  | typeof grantOrganizationUserRolesRequested
  | typeof grantOrganizationUserRolesSuccess
  | typeof grantOrganizationUserRolesFailed
  | typeof revokeOrganizationUserRolesRequested
  | typeof revokeOrganizationUserRolesSuccess
  | typeof revokeOrganizationUserRolesFailed
>;
